import { requestGet } from '@/utils/request';

const api = {
    LIST: '/finance/lotto_issue_stat_list',
};

export async function lottoIssueStatList(queryParams) {
    return requestGet(api.LIST, queryParams);
}